<app-notification-general></app-notification-general>
<div class="login">
  <div class="card">
    <div class="card-body">
      <div class="div-auth">
        <div class="title-div">
          <img src="{{ images.logo }}" alt="logo" class="logo">
          <!-- h1>{{ title | translatePipe }}</h1 -->
        </div>
        <div class="content-login">
          <form ngNativeValidate (ngSubmit)="login()">
            <input placeholder="{{ 'auth.userName' | translatePipe }}" [(ngModel)]="userName" name="userName" type="text" required>
            <input placeholder="{{ 'auth.password' | translatePipe }}" [(ngModel)]="password" name="password" type="{{ showPassword ? 'text' : 'password' }}" required>
            <app-button class="btn" type="submit" [classCss]="'login'" [text]="'auth.login'"></app-button>
            <div class="row div-pass-recovery">
              <div class="col-12">
                <a (click)="openDialog()" class="float-right">{{ 'auth.passwordRecoveryLink' | translatePipe }}</a>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
